import { SERVICES } from "@/data/services";
import { ServiceCard } from "@/components/site/ServiceCard";
import { CtaBanner, PageHeader } from "@/components/site/SiteLayout";
import { PackagesSection } from "@/components/site/PackagesSection";

const STEPS = [
  ["Discover", "A focused call to understand goals, audience and constraints."],
  ["Plan", "Scope, sitemap, fixed quote and a dated timeline."],
  ["Build", "Weekly previews on a live staging link. No black box."],
  ["Launch & care", "Go-live, monitoring and ongoing improvements."],
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader eyebrow="// services" title="Six ways we move your business forward." testId="services-title">
        Every engagement is built by the same small senior team, with clear scope, fixed pricing and code you own outright.
      </PageHeader>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-12">
        <div data-testid="services-grid" className="grid gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
          {SERVICES.map((s, i) => <ServiceCard key={s.id} service={s} index={i} />)}
        </div>
      </section>
      <section className="border-y border-white/5 bg-[#0A0D15]">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-12">
          <p className="mb-3 font-mono-tech text-xs uppercase tracking-[0.25em] text-cyan-400">// process</p>
          <h2 className="mb-12 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">How a project runs.</h2>
          <ol className="grid gap-8 md:grid-cols-4">
            {STEPS.map(([t, d], i) => (
              <li key={t} className="border-t border-cyan-400/30 pt-5">
                <span className="font-mono-tech text-xs text-cyan-400">0{i + 1}</span>
                <h3 className="mt-2 text-lg font-semibold text-white">{t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{d}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>
      <PackagesSection />
      <CtaBanner />
    </div>
  );
}
